<template>
    <Modal padding="m" size="s" :title="t({ key: 'shared.example' })">
        <div class="passport">
            <div class="passport-section">
                <span class="passport-names-title">
                    {{ t({ key: 'shared.name_in_passport' }) }}
                </span>
                <div
                    v-for="(passenger, i) in passportPassengersExample"
                    class="passport-names-label"
                    :key="i">
                    {{ t({ key: passenger.firstName }) }}
                    <span :class="{ 'passport-names-label-primary': marketIsSweden }">
                        {{ t({ key: passenger.firstNamePrimary }) }}
                    </span>
                    {{ t({ key: passenger.lastName }) }}
                </div>
            </div>
            <div class="passport-section">
                <span class="passport-names-title">
                    {{ t({ key: 'shared.enter_first_name' }) }}
                </span>
                <div
                    v-for="(passenger, i) in passportPassengersExample"
                    class="passport-names-label"
                    :key="i">
                    {{ t({ key: passenger.firstName }) }}
                    {{ t({ key: passenger.firstNamePrimary }) }}
                </div>
            </div>
            <div class="passport-section">
                <span class="passport-names-title">
                    {{ t({ key: 'shared.enter_last_name' }) }}
                </span>
                <div
                    v-for="(passenger, i) in passportPassengersExample"
                    :key="i"
                    class="passport-names-label">
                    {{ t({ key: passenger.lastName }) }}
                </div>
            </div>
            <div v-if="marketIsSweden" class="passport-section passport-disclaimer">
                {{ t({ key: 'shared.given_name_disclaimer' }) }}
            </div>
        </div>
    </Modal>
</template>
<script lang="ts">
    import { computed, defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { Market, Markets } from '@shared/config/market/market.models';
    import { useStore } from 'vuex';
    import Modal from '@ui/components/Modal/Modal.vue';

    export default defineComponent({
        name: 'PassportExamples',
        components: { Modal },
        methods: {
            t,
        },
        setup() {
            const store = useStore();

            const market = computed((): Market => store.getters['general/getMarket']);
            const marketIsSweden = computed<boolean>(() => {
                const marketNumber = market.value?.number;
                return (
                    marketNumber === Markets.SWEDEN || marketNumber === Markets.STENASWEDEN
                );
            });

            const passportPassengersExample = computed(() => [
                {
                    firstNamePrimary: 'shared.passport_male_first_name_primary',
                    firstName: 'shared.passport_male_first_name',
                    lastName: 'shared.passport_male_last_name',
                },
                {
                    firstNamePrimary: 'shared.passport_female_first_name_primary',
                    firstName: 'shared.passport_female_first_name',
                    lastName: 'shared.passport_female_last_name',
                },
            ]);

            return {
                passportPassengersExample,
                marketIsSweden,
            };
        },
    });
</script>
<style lang="scss" scoped>
    @use '@/styles/import.scss' as *;

    .passport {
        @include flex(column);
        gap: var(--spacing-16);
        line-height: 20px;
        color: var(--color-neutral-70, #333);

        &-names {
            &-title {
                @include font-label-l-bold();
            }

            &-label {
                @include font-body-m();

                &-primary {
                    text-decoration: underline;
                }
            }
        }
        &-disclaimer {
            font-style: italic;
            @include font-body-m();
        }
    }
</style>
